import produce from 'immer';
import {
  GET_FRAUD_ORDERS_START,
  GET_FRAUD_ORDERS_SUCCESS,
  GET_FRAUD_ORDERS_FAILED,
  UPDATE_FRAUD_ORDER_STATUS_START,
  UPDATE_FRAUD_ORDER_STATUS_SUCCESS,
  UPDATE_FRAUD_ORDER_STATUS_FAILED
} from '../actions/sales';

import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';


const initialState = {
  fraudOrders: [],
  fraudOrdersLoading: false,
  updateFraudOrderLoading: false,
  noFraudOrders: false
};


const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_FRAUD_ORDERS_START: {
      state.fraudOrdersLoading = true;
      break;
    }

    case GET_FRAUD_ORDERS_SUCCESS: {
      const {data} = action;
      state.fraudOrders = data;
      state.fraudOrdersLoading = false;
      break;
    }

    case GET_FRAUD_ORDERS_FAILED: {
      const {error} = action;
      state.fraudOrdersLoading = false;

      if (error.response.data.status == 404) {
        state.noFraudOrders = true;
      }

      break;
    }

    case UPDATE_FRAUD_ORDER_STATUS_START: {
      state.updateFraudOrderLoading = true;
      break;
    }

    case UPDATE_FRAUD_ORDER_STATUS_SUCCESS: {
      const {data} = action;

      state.fraudOrders = state.fraudOrders.map((order) => {
        return order.entity_id === data.entity_id ?
          {...order, status: data.status, state: data.status} : order;
      });
      state.updateFraudOrderLoading = false;
      break;
    }

    case UPDATE_FRAUD_ORDER_STATUS_FAILED: {
      state.updateFraudOrderLoading = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.fraudOrders = [];

      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
